export class CookieHelper {
  public static get(self: any, key: string) {
    const value = self.$cookie.get(key);
    if (value)
      return Promise.resolve(value);
    return Promise.reject(value);
  }

  public static set(self: any, key: string, value: any, expires?: string) {
    if (expires) {
      self.$cookie.set(key, value, { expires });
      return;
    }
    self.$cookie.set(key, value);
  }

  public static delete(self: any, key: string) {
    self.$cookie.delete(key);
  }
}


// WEBPACK FOOTER //
// ./src/utils/CookieHelper.util.ts